import React from 'react'
import { OnBeforeNavigatePipeline } from '@morningtrain/react-navigation'
import ConfirmOnPipe from 'support/pipelines/ConfirmOnPipe'
import { CallbackOnPipe, ConditionalNestedPipeline } from '@morningtrain/react-helpers'
import { useForm } from '@morningtrain/react-resources'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'

export default function ConfirmFormChangesBeforeNavigate () {
  const form = useForm()

  return (
    <OnBeforeNavigatePipeline>
      <CallbackOnPipe
        callback={p => {
          p.form_has_changed = form.isChanged()
          return p
        }}
      />
      <ConditionalNestedPipeline when='form_has_changed' matches>
        <ConfirmOnPipe
          content={(
            <UI.Text>
              <Translation name='generic.form_has_changes' />
            </UI.Text>
        )}
        />
      </ConditionalNestedPipeline>
    </OnBeforeNavigatePipeline>
  )
}
